import React, {useEffect, useState} from 'react';
import {useDebounce} from 'use-debounce';
import API from '../../../app/api';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import _ from 'lodash';
import AgyleDictionaryField from '../../../components/ui/selector/agyleDictionaryField';
import Avatar from '@mui/material/Avatar';
import {useTranslation} from 'react-i18next';
import PhoneIcon from '@mui/icons-material/Phone';
import {escapeRegExp} from '../../../pages/ward/forms/formsUtil';

const columnToSearch = ['_id', 'practiceName', 'address.addressLines', 'address.postalCode'];

const ControlSurgery = (props) => {
    const {t} = useTranslation();

    // Options
    const [opt, setOpt] = useState([]);
    const [loading, setLoading] = useState(false);

    const [search, setSearch] = useState('');
    const [searchValueDebounced] = useDebounce(search, 250);
    const controller = new AbortController();

    useEffect(() => {
        return () => {
            controller.abort();
        };
    }, []);

    useEffect(() => {
        if (!_.isEmpty(searchValueDebounced) || props.gp) {
            let filter = 'deactivated ne true';
            let paging = '';

            if (props.gp?.surgery) {
                const surgeryId = props.gp?.surgery?.href?.replace('/surgeries/', '');
                filter += ` and _id eq '${surgeryId}'`;
            } else {
                if (props.dontTrimSearch) {
                    filter = getFilter(searchValueDebounced, filter, escapeRegExp);
                } else {
                    for (let term of searchValueDebounced.split(" ")) {
                        filter = getFilter(term, filter, escapeRegExp);
                    }
                }
                paging = '&$pageSize=50&$page=1';
            }

            API.getDictByURL(`/surgeries?$filter=${encodeURIComponent(filter)}${paging}`, controller.signal)
                .then(dictData => {
                    if (dictData && dictData.__data && !_.isEmpty(dictData.__data)) {
                        let data = dictData.__data;
                        setOpt(data);
                    } else {
                        setOpt([]);
                    }
                    setLoading(false);
                });
        }
        return () => {
        };
    }, [searchValueDebounced, props.gp]);

    function getFilter(input, filter) {
        if (!_.isEmpty(input)) {
            if (!_.isEmpty(filter)) filter += ' AND ';
            for (let i = 0; i < columnToSearch?.length; i++) {
                if (i > 0) {
                    filter += ' or ';
                }
                filter += `${columnToSearch[i]} regex '.*` + escapeRegExp(input) + `.*'`;
            }
        }
        return filter;
    }

    const getVal = (value) => {
        if (value && value !== 'null') return value;
        return '';
    };

    const renderOptionLine = (props, option, test) => {
        return (
            <Box key={option?.__id} component="li" sx={{fontSize: 'small'}} {...props}>
                <Chip
                    avatar={<Avatar>{t('Id')}</Avatar>}
                    label={option?.__id} size="small" sx={{mr: 1}}
                />
                <b style={{fontSize: 'medium'}}>{getVal(option?.practiceName)}</b>
                <i style={{marginLeft: 5}}>
                    {!_.isEmpty(option?.addresses) ? getAddress(option?.addresses) : ''}
                </i>
                {option?.phoneNumbers &&
                    <div
                        style={{
                            marginLeft: 10,
                            display: 'flex',
                            flexWrap: 'nowrap',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}
                    >
                        <PhoneIcon/> {getPhone(option?.phoneNumbers)}
                    </div>
                }
            </Box>
        );
    };

    const getAddress = (addresses) => {
        const address = addresses[0];
        let text = address.postalCode ? `[${address.postalCode}] ` : '';
        if (address.addressLines && address.addressLines.length > 0) {
            address.addressLines.forEach(add => {
                text += add + ' ';
            });
        }
        return text;
    };

    const getPhone = (phones) => {
        if (phones[0]) return phones[0].phone;
    };

    const renderLabel = (option) => {
        return (
            `[${option?.__id}] [${getVal(option?.practiceName)}] ` +
            `${!_.isEmpty(option?.addresses) ? getAddress(option?.addresses) : ''} ` +
            `${!_.isEmpty(option?.phoneNumbers) ? `[${getPhone(option?.phoneNumbers)}] ` : ''} `
        );
    };

    const handleInputChange = (_e, val) => {
        setSearch(val);
    };

    const handleChange = (e, val) => {
        props.onChange(val, e);
    };

    return (
        <AgyleDictionaryField
            label={props.label}
            options={opt}
            onChange={handleChange}
            value={props.value}
            onInputChange={handleInputChange}
            getOptionLabel={renderLabel}
            renderLocalOption={renderOptionLine}
            isOptionEqualToValue={(opt, val) => opt.__id === val.__id}
            size={props.size || 'medium'}
            loading={loading}
            noBorder={props?.noBorder}
            disabled={props.disabled}
            error={props.error}
            placeholder={props.placeholder}
        />
    );
};

export default ControlSurgery;